import { BrandedProductId, PremiumProductId } from '@seek/hirer-products-shim';

import type {
  CatalogueProduct,
  Maybe,
  Money,
  Tax,
} from 'src/graphql/generated';

type GetPremiumUpgradePriceParams<T> = {
  productSet?: T | null;
  hidePrice?: boolean | null;
};

export const getPremiumUpgradePrice = <
  T extends { items: Maybe<CatalogueProduct>[] },
>({
  productSet,
  hidePrice,
}: GetPremiumUpgradePriceParams<T>): {
  price?: Money;
  tax?: Tax;
} => {
  const premiumPrice = productSet?.items?.find(
    (item) => item?.id === PremiumProductId,
  )?.price;
  const brandedPrice = productSet?.items?.find(
    (item) => item?.id === BrandedProductId,
  )?.price;

  let price;
  let tax;

  if (
    !hidePrice &&
    premiumPrice?.__typename === 'Price' &&
    brandedPrice?.__typename === 'Price'
  ) {
    if (premiumPrice.netPrice.value && brandedPrice.netPrice.value) {
      price = {
        value: premiumPrice.netPrice.value - brandedPrice.netPrice.value,
        currency: premiumPrice.netPrice.currency,
      };
      tax = premiumPrice.tax;
    }
  }

  const isValid = price && isFinite(price.value);

  return {
    price: isValid ? price : undefined,
    tax: tax ?? undefined,
  };
};
